import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    '&.Mui-disabled': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
      border: 0,
      marginLeft: 0,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
      border: 0,
    },
  },
}));
